export const CONTRACT_TYPE = {
  FIXED: 'fixed',
  FIXED_UNITARY: 'fixed-unitary',
  STANDARD: 'standard',
  NIGHTLY: 'nightly',
  FORTNIGHT: 'fortnight',
  MONTHLY: 'monthly'
};

export const AVAILABILITY_TYPE = {
  STANDARD: 'standard',
  STANDARD_UNITARY: 'standard-unitary'
};
